<template lang="">
  <section>
    <div class="bodyy">
      <div class="headline">
        <div>
          <h1>
            Explore a <b>História</b> através de <br />
            <b>Objetos de Aprendizagem</b>
          </h1>
        </div>
        <div>
          <p>
            Conheça o BaoBaH, uma comunidade gratuita que te ajuda a encontrar
            diversos <br />
            Objetos de Aprendizagem de forma fácil.
          </p>
        </div>
      </div>

      <!-- <div> -->
      <div class="search">
        <form id="separater" @submit.prevent="querySearch()">
          <container class="leading">
            <img class="imgSearch" src="../../assets/leading.png" alt="" />
            <input
              style="color: black; background-color: var(--white)"
              type="text"
              src="../assets/leadingIcon.png"
              alt=""
              placeholder="Pesquise OAs"
              v-model="search"
            />
          </container>
          <button class="btnAcess" type="submit"><p>Buscar</p></button>
        </form>

        <div class="filters" v-if="filters">
          <!-- <div class="fInput">
            <p>Tags</p>
            <input type="text" placeholder="Digite uma palavra-chave" />
          </div> -->
          <div class="fInput">
            <p>Espaço</p>
            <select
              v-model="selectedlocation"
              @change="updateSelectedLocation"
              name=""
              id=""
            >
              <!-- <option :value="null" disabled selected>Todos</option> -->
              <option value="all" selected>Todos</option>
              <option
                v-for="loc in locations"
                :key="loc.id"
                :value="loc.id"
                :selected="selectedlocation === loc.id"
              >
                {{ loc.name }}
              </option>
            </select>
          </div>
          <div v-if="false" class="fInput">
            <p>Temporalidade</p>
            <select
              v-model="selectedTemp"
              name=""
              id=""
              @change="updateSelectedTemp"
            >
              <!-- <option :value="null" disabled selected>Todos</option> -->
              <option value="all" selected>Todos</option>
              <option
                v-for="temp in temporalities"
                :key="temp.id"
                :value="temp.id"
                :selected="selectedTemp === temp.id"
              >
                {{ temp.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </section>
</template>

<script>
import { defineComponent } from "vue";
import { mapActions } from "vuex";
import axios from "axios";
import api from "@/services/api";
export default defineComponent({
  name: "MyHero",
  props: {
    watchEnabled: {
      type: Boolean,
      default: false,
    },
    isHome: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filters: true,
      search: "",
      locations: [],
      selectedlocation: null,
      temporalities: [],
      selectedTemp: null,
    };
  },
  methods: {
    ...mapActions(["AgetOas", "setSearch", "setLocation", "setTemporality"]),
    updateSelectedLocation(event) {
      const selectedValue = event.target.value;
      if (selectedValue === "all") {
        this.selectedlocation = null;
      } else {
        this.selectedlocation = selectedValue;
      }
      this.$store.commit("setLocation", this.selectedlocation);
    },
    updateSelectedTemp(event) {
      const selectedValue = event.target.value;
      if (selectedValue === "all") {
        this.selectedTemp = null;
      } else {
        this.selectedTemp = selectedValue;
      }
      this.$store.commit("setTemporality", this.selectedTemp);
    },
    querySearch() {
      this.$store.commit("setSearch", this.search);
      this.$store.dispatch("AgetOas");
      this.$router.push(`/oas/${this.search}`);
    },
    async fetchLocations() {
      try {
        const response = await api.get("location/");
        this.locations = response.data;
      } catch (error) {
        console.error("Erro ao obter os espaços:", error);
      }
    },
    async fetchTemporalities() {
      try {
        const response = await api.get("temporality/");
        this.temporalities = response.data;
      } catch (error) {
        console.error("Erro ao obter as temporalidades:", error);
      }
    },
  },
  mounted() {
    this.fetchLocations();
    this.fetchTemporalities();
    this.selectedlocation = this.$store.state.location;
    this.selectedTemp = this.$store.state.temporality;
    if (this.isHome) {
      this.$store.commit("setTemporality", null);
      this.$store.commit("setLocation", null);
      this.$store.commit("setSearch", null);
      this.$store.dispatch("AgetOas");
    }
  },
  watch: {
    selectedlocation: function (newLocation, oldLocation) {
      if (this.watchEnabled && newLocation !== oldLocation) {
        this.$store.commit("setLocation", newLocation);
        this.$store.dispatch("AgetOas");
      }
    },
    selectedTemp: function (newTemp, oldTemp) {
      if (this.watchEnabled && newTemp !== oldTemp) {
        this.$store.commit("setTemporality", newTemp);
        this.$store.dispatch("AgetOas");
      }
    },
  },
});
</script>
<style scoped lang="css">
section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-image: url(../../assets/background2.svg);
  background-size: cover;
  background-repeat: no-repeat;
}
.bodyy {
  height: 60vh;
  margin: 50px;
}
b {
  color: var(--yellow);
}
h1,
p {
  color: var(--white);
}

h1 {
  font-size: 48px;
}
.headline {
  display: flex;
  flex-direction: column;
  padding: 30px;
  gap: 30px;
}
.headline p {
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.search {
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
}
#separater {
  display: flex;
  justify-content: space-between;
}
.filters {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.fInput {
  width: 30%;
  gap: 10px;
}
.fInput p {
  color: var(--white);
  margin-bottom: 5px;
  text-align: start;
}
.fInput input,
select {
  width: 100%;
  padding-left: 10px;
  min-height: 44px;
  border-radius: 4px;
  border: 1px solid var(--silver-medal, #c4c4c4);
  background-color: var(--white, #ffffff);
  color: var(--black, #000000);
}
.fInput option {
  color: var(--black, #000000);
}
.leading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: 85%;
}
.leading p {
  color: var(--orange);
}
.leading input {
  padding-left: 40px;
  height: 44px;
  border-radius: 4px;
  border: 1px solid var(--silver-medal);
}
.leading button {
  display: flex;
  height: 40px;
  flex-direction: row;
  position: absolute;
  right: 2px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  border: none;
  background-color: var(--white);
}
.imgSearch {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  height: 20px;
  width: 20px;
}
.btnAcess {
  display: flex;
  height: 44px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 4px;
  background: var(--orange);
  border: none;
  cursor: pointer;
}
</style>
